import React from 'react';
import { Button } from 'antd';
import useDownloadAiContentAnalysisPdf from '../../reportRenderEngine/hooks/useDownloadAiContentAnalysisPdf';

type Props = {
    domain: string;
    disabled: boolean;
};

export default function DownloadPdfButton({ domain, disabled }: Props) {
    const { downloadPdf, isDownloadingPdf } = useDownloadAiContentAnalysisPdf();

    return (
        <Button
            className="download-pdf-button"
            size="small"
            disabled={disabled || isDownloadingPdf}
            icon={isDownloadingPdf ? 'loading' : 'file-pdf'}
            onClick={() => downloadPdf(domain)}
        >
            Download PDF
        </Button>
    );
}
